export default __webpack_public_path__ + "static/media/danger@2x.12cde65d.jpg";